﻿import "@babel/polyfill";
import { armundiaInit } from 'arm-common';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter, Route, Switch } from "react-router-dom";
import AppActions from './app/app_actions';
import { AppConstants } from './constants/AppConstants';
import { store } from './store';
import MainReactApp from './ui/MainReactApp.jsx';

console.log("Starting " + AppConstants.APP_NAME + "...");

//const store = createStore(
//  rootReducer,
//    applyMiddleware(thunk),
//);

let ac = AppActions.pushI18nLabel;
armundiaInit(store, ac);

ReactDOM.render(
    <Provider store={store} >
        <HashRouter>
            <Switch>
                <Route path="/" component={MainReactApp} />
            </Switch>
        </HashRouter >
    </Provider>,

    document.getElementById('main-react-app')
);